import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import GenerateReport from './GenerateReport';
import ConversationTabSetting from './conversation/ConversationTabSetting'
import Statistics from './statistics/Statistics';
import ReportsSubPage from './ReportsSubPage';
import $ from 'jquery';
import AuditTabSettings from './audit/AuditTabSettings';
import BotStoreReportTabSetting from './botStore/BotStoreReportTabSetting';
import OutreachPrograms from '../testAndDeploy/OutreachPrograms';

class ReportSettings extends Component {
  constructor() {
    super();
    this.state = {
      projectId: null,
      hideBotStore: false
    }
  }
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;
      var path = window.origin + "/platform/projectmgmt/reports";
      var path1 = window.origin + "/platform/projectmgmt/reports/";
      if (currentPath === path || currentPath === path1) {
        $("#statistics-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/reports/GenerateReport')) {
        $("#generate-report-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/reports/ConversationTabSetting')) {
        $("#conversation").addClass('active');
      } else if (currentPath.includes('/projectmgmt/reports/settings')) {
        $("#settings-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/reports/audit')) {
        $("#audit-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/reports/bot-store')) {
        $("#bot-store-tab").addClass('active');
      } else if (currentPath.includes('/projectmgmt/reports/telephony-outreach')) {
        $("#telephony-outreach-tab").addClass('active');
      } else {
        $("#" + localStorage.getItem("last-used-report-settings-tab")).addClass('active')
      }
      $("#generate-report-tab,#conversation,#statistics-tab,#settings-tab,#audit-tab,#bot-store-tab,#telephony-outreach-tab")
        .on("click", function () {
          $("#generate-report-tab,#conversation,#statistics-tab,#settings-tab,#audit-tab,#bot-store-tab,#telephony-outreach-tab")
            .removeClass('active');
          localStorage.setItem("last-used-report-settings-tab", $(this)[0].id);
          $(this).addClass('active')

        })

      $("#statistics-tab").on("click", function () {
        $("#daily-reports,#monthly-conv-data,#weekly-conv-data,#output-spreadsheets,#summary")
          .removeClass('active');
        $("#summary").addClass('active');
      })

      $("#settings-tab").on("click", function () {
        $("#kpi-tab,#schedule-tab")
          .removeClass('active');
        $("#kpi-tab").addClass('active');
      })

      $("#audit-tab").on("click", function () {
        $("#audit-dev-tab,#audit-support-tab")
          .removeClass('active');
        $("#audit-dev-tab").addClass('active');
      })

      $("#bot-store-tab").on("click", function () {
        $("#review-tab,#tickets-tab")
          .removeClass('active');
        $("#review-tab").addClass('active');
      })

    })();
    if (localStorage.getItem("currentProjectId") == null) {
      this.fetchDetailsApi();

    }
    this.fetchProjectDetailsApi();

    var thisController = this;
    thisController.state.projectId = localStorage.getItem("currentProjectId");
    thisController.setState(thisController.state);
    document.addEventListener("projectChanged", function (event) {
      thisController.state.projectId = localStorage.getItem("currentProjectId");
      thisController.setState(thisController.state);
      thisController.projectId = event.projectId;
      thisController.fetchProjectDetailsApi(event.projectId);
    });
  }
  fetchDetailsApi() {
    var projectSettingComponent = this;
    $.ajax({
      url: "/api/project",
      async: false,
      method: 'GET',
      data: { "userId": JSON.parse(localStorage.getItem("user_details"))["userId"] },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          localStorage.setItem("currentProjectId", res.result[0].id);
          projectSettingComponent.state.projectId = localStorage.getItem("currentProjectId");
          projectSettingComponent.setState(projectSettingComponent.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
  }
  fetchProjectDetailsApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var detailsController = this;
    $.ajax({
      url: "/api/project-details",
      async: false,
      method: 'GET',
      data: {
        "projectId": projectId
      },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          if (res.result.isAnApp != null && res.result.isAnApp == true) {
            detailsController.state.hideBotStore = true;
            detailsController.setState(detailsController.state);
            if (window.location.href.includes("/platform/projectmgmt/reports/bot-store")) {
              window.location.href = "/platform/projectmgmt/reports";
            }

          } else {

            detailsController.state.hideBotStore = false;
            detailsController.setState(detailsController.state);
          }

        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  fetchDetailsApi() {
    var projectSettingComponent = this;
    $.ajax({
      url: "/api/project",
      async: false,
      method: 'GET',
      data: { "userId": JSON.parse(localStorage.getItem("user_details"))["userId"] },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          localStorage.setItem("currentProjectId", res.result[0].id);
          projectSettingComponent.state.projectId = localStorage.getItem("currentProjectId");
          projectSettingComponent.setState(projectSettingComponent.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
  }

  render() {

    const { showOnlyReport } = this.props;
    console.log("Props passed : ", showOnlyReport);
    console.log("actual props Object : ", this.props);

    return (

      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <div className="content-header" >
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">Reports</h1>
                  <h6 className="taglineTxt">Agent Performance Insights</h6>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid" >
            <div className="border-bottom"></div>
            {/* Nav tabs */}
            <div className="tab-class">
              <ul className="nav nav-tabs border-bottom navCluster" >
                <Link to="/projectmgmt/reports" className="nav-item"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="statistics-tab">
                    Statistics
                  </li></Link>
                <Link to="/projectmgmt/reports/conversation" className="nav-item"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="conversation">
                    Conversation
                  </li></Link>
                <Link to="/projectmgmt/reports/generate-report" className="nav-item"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="generate-report-tab">
                    Generate Report
                  </li></Link>
                <Link to="/projectmgmt/reports/settings" className="nav-item"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="settings-tab">
                    Schedule Report
                  </li></Link>
                <Link to="/projectmgmt/reports/audit" className="nav-item"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="audit-tab">
                    Personnel Audit
                  </li></Link>
                <Link to="/projectmgmt/reports/bot-store" className="nav-item"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="bot-store-tab"
                    style={{ display: this.state.hideBotStore ? 'none' : 'block' }}
                  >
                    Bot Store
                  </li></Link>
                <Link to="/projectmgmt/reports/telephony-outreach" className="nav-item"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="telephony-outreach-tab"
                    style={{ display: showOnlyReport ? 'block' : 'none' }}
                  >
                    Telephony Outreach Programs
                  </li></Link>
              </ul>
            </div>
          </div>
        </div>
        <Switch>
          <Route path="/projectmgmt/reports/bot-store" component={BotStoreReportTabSetting}></Route>
          <Route path="/projectmgmt/reports/telephony-outreach" component={OutreachPrograms}></Route>
          <Route path="/projectmgmt/reports/audit" component={AuditTabSettings}></Route>
          <Route path="/projectmgmt/reports/conversation" component={ConversationTabSetting}></Route>
          <Route path="/projectmgmt/reports/generate-report" component={GenerateReport}></Route>
          <Route path="/projectmgmt/reports/settings" component={ReportsSubPage}></Route>
          <Route path="/projectmgmt/reports" component={Statistics}></Route>


        </Switch>
      </div>

    );
  }
}
export default ReportSettings;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/reportSettings.js